<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top">
    <el-row :gutter="5">
      <el-col :xs="14" :sm="8" :md="8" :lg="6" :xl="6">
        <el-form-item :label="$t('cep')" prop="cep" class="is-required">
          <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zipcode()"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item :label="$t('endereco')" prop="address" class="is-required">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="12" :sm="24" :md="18" :lg="12" :xl="12">
        <el-form-item :label="$t('bairro')" prop="neighborhood" class="is-required">
          <el-input v-model="ruleForm.neighborhood"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <el-form-item :label="$t('cidade')" prop="city" class="is-required">
          <el-input v-model="ruleForm.city" maxlength="80"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="3">
        <el-form-item :label="$t('estado')" prop="state" class="is-required">
          <el-input v-model="ruleForm.state" maxlength="2" class="uppercase"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="4">
        <el-form-item :label="$t('numero')" prop="number" class="is-required">
          <el-input maxlength="6" v-model="ruleForm.number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
        <el-form-item :label="$t('complemento')" prop="extent">
          <el-input v-model="ruleForm.extent" maxlength="255"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template> 
<script>

import ZipMixins from "@/xpost/mixins/zipcode";
export default {
  name: "ShippingAddFormInfoZipcode",
  mixins: [ZipMixins],
  computed: {
    data() {
      return this.ruleForm;
    }
  },
  methods: {
    setData(ruleForm) {
      this.ruleForm.cep = ruleForm.address.zipcode;
      this.ruleForm.address = ruleForm.address.address;
      this.ruleForm.city = ruleForm.address.city;
      this.ruleForm.neighborhood = ruleForm.address.neighborhood;
      this.ruleForm.state = ruleForm.address.state;
      this.ruleForm.number = ruleForm.address.number;
      this.ruleForm.extent = ruleForm.address.extent;
    }
  },
  data() {
    return {
      ruleForm: {
        cep: '',
        address: '',
        city: '',
        neighborhood: '',
        state: '',
        number: '',
        extent: '',
      }
    };
  },
}
</script>
